import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiAudit from "./../../assets/images/banner/ai-audit.png";
import { Link, useLocation } from "react-router-dom";

const AI_Audit_Compliance = () => {
  pageTitle("RPA in Audit and Compliance");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Your logic to handle form submission goes here

    console.log("Form submitted:", formData);

    // Clear the form fields after submission if needed

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const servicesData = [
    { id: 1, title: "AI_Accounting_Finance", slug: "/AI_Accounting_Finance" },
    { id: 2, title: "AI-Audit-Compliance", slug: "/AI-Audit-Compliance" },
    { id: 3, title: "AI-Human-Resources", slug: "/AI-Human-Resources" },
    { id: 4, title: "AI-Operations", slug: "/AI-Operations" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <HeaderOne></HeaderOne>
<div className="ai-overlay-wrapper">
  <img
    src={aiAudit}
    alt="AI Operations"
    className="img-fluid"
  />

  <div className="ai-overlay">
    <h2>AI Audit and Compliance</h2>
  </div>
</div>
      {/* RPA Accounting Impact Section */}
      <section className="rpa-af-section">
        <div className="container">
          {/* FULL WIDTH INTRO */}
          <div className="row">
            <div className="col-12">
              <div className="rpa-af-content">
                <h2 className="rpa-af-title">
                  RPA for Accounting and Finance Processes
                </h2>

                <p className="rpa-af-desc">
                  <span className="rpa-af-dropcap">T</span>
                  oday{" "}
                  <span className="rpa-af-highlight">
                    Robotic Process Automation
                  </span>{" "}
                  (RPA)  has shown to be extremely effective in automating repetitive, high volume processes without human error, especially when organizations are attempting to do more with less. Auditors every day face a multitude of challenges in gathering data for preparation and preprocessing because the data is typically inconsistent, incomplete, and lacks the needed format/structure to make it into an auditable form. By nature, controls depend upon monotonous activity and a high-level of documentation, making these functions ideal candidates for automation.
                </p>
              </div>
            </div>
          </div>

          {/* TWO COLUMN SECTION */}
          <div className="row align-items-center mt-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              <h3 className="rpa-af-subtitle">What’s the Impact?</h3>

              <p className="rpa-af-desc">
               The impact of RPA for audit and control boosts productivity, saving an outstanding amount of time by streamlining report corrections and improving data accuracy. By deploying RPA, businesses can automate time-consuming, manual tasks of copying and pasting data between applications, cross-referencing data, and reconciling. With an automation implementation, auditors would have more time to prioritize value-added efforts and high-priority audits, and the organization will have increased compliance and reduced risk across the board.
              </p>
              <p className="rpa-af-desc mt-3">
                When automated control testing is implemented, internal audits can analyze entire populations of data instead of samplings. This results in management having more confidence that these audit controls are operating adequately.
              </p>
            </div>

            {/* RIGHT CARD */}
            <div className="col-lg-4">
              <div className="rpa-af-stats-card">
                <div className="rpa-af-stats-row">
                  <div className="rpa-af-stat">
                    <div>
                      <h4>97%</h4>
                    </div>
                  </div>
                </div>
                <p className="rpa-af-case-text">
                  By automating the creation and distribution of standard settlement instructions, we experienced a 97% reduction in processing time
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RPA Use Cases Section */}
      <section className="rpa-uc-section">
        <div className="container">
          <div className="row align-items-start">
            {/* LEFT GRADIENT CARD */}
            <div className="col-lg-4">
              <div className="rpa-uc-card">
                <div className="rpa-uc-card-icon">
  <i className="fa-solid fa-scale-balanced"></i>
</div>


                <h3 className="rpa-uc-card-title">
                 Automating Audit and Compliance
                </h3>

                <ul className="rpa-uc-card-list">
                  <li>Improve operational efficiencies & quality of audit</li>
                  <li>Increase control testing coverage</li>
                  <li>Instill agility in compliance management</li>
                  <li>Higher precision audit activities</li>
                </ul>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8">
              <div className="rpa-uc-content">
                <h2 className="rpa-uc-heading">
                  RPA Use Cases for Audit and Compliance
                </h2>

                <ul className="rpa-uc-list">
                  <li>
                      <strong>Executing and Tracking Internal Audits:</strong> Automate data collection, execute the audit plan and track against it, gather evidence, and control testing
                  </li>

                  <li>
                    
                      <strong>Reporting and Monitoring Audits: </strong>  Auto-prepare reports and dashboards, populate audit committee report templates, prepare and deliver internal audit balanced scorecard, monitor Key Risk Indicators (KRI), and provide near-time insights
                   
                  </li>

                  <li>
             
                      <strong>Managing Audit Data Quality:</strong> Automating master data to have completeness of information in order to manage evidence and have a platform to validate the data
              
                  </li>

                  <li>
             
                      <strong>Providing Audit Alerts and Notifications:</strong> Identify open audit items, notify responsible parties if there is an error, alert notifications when due dates aren’t met, and document remediation status
            
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_Audit_Compliance;
